import { useEffect, useState } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase/config';

/**
 * The company's name, as somebody would recognise it (§7).
 *
 * One read of the org document, which holds the name the content pack was
 * authored with. Everything else in the app is keyed by the org *id*, and an id
 * is a slug — hyphenated and lower-cased — which is fine in a path and wrong
 * on a screen. It
 * matters more now that one person can be moved between companies and needs to
 * know which one they are looking at.
 *
 * Falls back to the id, so a company whose document is missing still renders.
 */
export function useOrgName(orgId: string | null): string | null {
  const [name, setName] = useState<string | null>(null);

  useEffect(() => {
    if (!orgId) { setName(null); return; }
    let cancelled = false;
    // Show the id immediately rather than a gap that fills in a moment later.
    setName(orgId);
    getDoc(doc(db, `orgs/${orgId}`))
      .then((snap) => {
        if (!cancelled) setName((snap.data()?.orgName as string | undefined) ?? orgId);
      })
      .catch((err) => console.error('could not read the company name', err));
    return () => { cancelled = true; };
  }, [orgId]);

  return name;
}
